<ng-template #priceContainer let-item="item">
    @if (item.price !== 0) {
        <div class="pull-right">
            @if (item.marked_price > item.price) {
                <span class="cust_strikethrough_text"> &#8377; {{ item.marked_price }} </span>
            }
            <span class="rupee">&#8377; {{ item.price }}</span>
        </div>
    }
</ng-template>
@if (product && product['grouped_ct']) {
    <group-customization
        [product]="product"
        [menuData]="menuData"
        [DEPLOY_URL]="DEPLOY_URL"
        (closeDialog)="close()"
        (submitCart)="updateCart($event)"
        [currentCustomization]="currentCustomization"></group-customization>
}
@if (product && !product['grouped_ct']) {
    <div class="flexbox-container">
        <div class="flex">
            <div class="flex-item border-right left" *appFeatureToggle="'desktop'">
                <!-- Web View left panel-->
                <div mat-dialog-title>
                    <!-- Overview Header -->
                    <div class="label-header">
                        @if (!product.veg) {
                            <img src="{{ DEPLOY_URL }}/assets/images/non-veg.svg" class="veg-nonveg" />
                        }
                        @if (product.veg) {
                            <img src="{{ DEPLOY_URL }}/assets/images/veg.svg" class="veg-nonveg" />
                        }
                        {{ product.label }}
                    </div>
                </div>
                <div class="ui-card-image" style="position: relative">
                    <img
                        src="{{ DEPLOY_URL }}/assets/images/missing.png"
                        class="main-product-image"
                        [alt]="product.description"
                        appDeferImageLoad
                        [imageSrc]="product.image" />
                </div>
                <div class="product-description">{{ product.description }}</div>
                <div class="d-price-container">
                    <div style="font-size: 20px">&#8377; {{ getFinalPrice() }}</div>
                    <ui-counter-button
                        [counter]="getProductQuantity()"
                        (onCounterChange)="updateQuantity($event)">
                    </ui-counter-button>
                </div>
            </div>
            <div class="flex-item right">
                <div (click)="close()" class="close-icon" *appFeatureToggle="'desktop'">
                    <img src="{{ DEPLOY_URL }}/assets/images/cross.svg" />
                </div>
                <!-- Mobile View Top -->
                <div *appFeatureToggle="'mobile'">
                    <img
                        src="{{ DEPLOY_URL }}/assets/images/missing.png"
                        class="mobile-product-image"
                        [alt]="product.description"
                        appDeferImageLoad
                        style="z-index: 1"
                        [imageSrc]="mainProductImage" />
                    <img src="{{ DEPLOY_URL }}/assets/images/left-arrow_white.svg" class="left-arrow" (click)="close()" />
                </div>
                <mat-dialog-content>
                    <div class="header-scroll">
                        <ng-container *appFeatureToggle="'mobile'">
                            <div class="customization-header">
                                <div class="product-name">
                                    <div class="label-header">
                                        @if (!product.veg) {
                                            <img class="veg-nonveg" src="{{ DEPLOY_URL }}/assets/images/non-veg.svg" />
                                        }
                                        @if (product.veg) {
                                            <img class="veg-nonveg" src="{{ DEPLOY_URL }}/assets/images/veg.svg" />
                                        }
                                        <div class="mobile-product-label">{{ product.label }}</div>
                                    </div>
                                    <div class="mobile-product-description">{{ product.description }}</div>
                                </div>
                            </div>
                        </ng-container>
                        <!--Size & Type Customizations-->
                        <div class="margin-right-panel conditional_layout">
                            <!-- ProductSizes -->
                            @if (toShowProductSizes()) {
                                <div class="row" style="margin: 0">
                                    <div class="description-header">
                                        <span class="type_label">Select a Size</span>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="text-center cs">
                                        <div class="cs_text">
                                            @for (product_size of product.product_sizes; track product_size) {
                                                <mat-radio-group>
                                                    <mat-radio-button
                                                        type="radio"
                                                        color="primary"
                                                        class="csrow_text"
                                                        (click)="toggleProductSize(product_size.id)"
                                                        [disableRipple]="true"
                                                        [checked]="isSelected('product_size', product_size.id)"
                                                        [value]="product_size"
                                                        [class.disabled]="product_size.sold_out">
                                                        <div class="inside_cust_text">
                                                            <div style="text-align: left">{{ product_size.label }}</div>
                                                            @if (product_size.price !== 0) {
                                                                <div style="text-align: right">
                                                                    <div>
                                                                        @if (
                                                                            getProductSizeMarkedPrice(product_size) >
                                                                            getProductSizePrice(product_size)
                                                                        ) {
                                                                            <span class="cust_strikethrough_text">
                                                                                &#8377;
                                                                                {{ getProductSizeMarkedPrice(product_size) }}
                                                                            </span>
                                                                        }
                                                                        <span class="rupee"
                                                                            >&#8377;
                                                                            {{ getProductSizePrice(product_size) }}
                                                                        </span>
                                                                    </div>
                                                                    @if (product_size.sold_out) {
                                                                        <div class="out-of-stock">OUT OF STOCK</div>
                                                                    }
                                                                </div>
                                                            }
                                                        </div>
                                                    </mat-radio-button>
                                                </mat-radio-group>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                            @if (toShowProductSizes()) {
                                <hr class="menu-cust" />
                            }
                            <!-- Customizations -->
                            <div class="conditional_height">
                                @for (customization_type of getAllCustomizationType(); track customization_type) {
                                    <div>
                                        @if (!customization_type.sold_out) {
                                            <div class="description-header">
                                                <span class="type_label">{{ customization_type.label }}</span>
                                                <span class="type_description">{{ customization_type.description }}</span>
                                            </div>
                                            <div class="clearfix"></div>
                                            <!-- Non-Pack Customizations -->
                                            <div class="col-sm-12 nopadding">
                                                @if (customization_type.show_images) {
                                                    <div class="cs_text conditional_width">
                                                        @for (
                                                            customization of getCustomizations(customization_type.id);
                                                            track customization
                                                        ) {
                                                            <mat-list class="csrow_text cb-wrapper">
                                                                @if (customization_type.show_images) {
                                                                    <mat-list-item
                                                                        color="primary"
                                                                        class="csrow_text"
                                                                        (click)="
                                                                            toggleCustomization(
                                                                                customization_type.id,
                                                                                customization.id
                                                                            )
                                                                        "
                                                                        [disableRipple]="true"
                                                                        [checked]="isSelected('customization', customization.id)"
                                                                        [value]="customization">
                                                                        <ui-card
                                                                            class="csbox border_cust"
                                                                            [ngClass]="{
                                                                                add_back_color: isSelected(
                                                                                    'customization',
                                                                                    customization.id
                                                                                )
                                                                            }">
                                                                            <div class="ui-card-image">
                                                                                <img
                                                                                    src="{{
                                                                                        DEPLOY_URL
                                                                                    }}/assets/images/plus_2.svg"
                                                                                    class="tick_style" />
                                                                                <img
                                                                                    src="{{ DEPLOY_URL }}/assets/images/plus.svg"
                                                                                    class="plus" />
                                                                                <img
                                                                                    src="{{
                                                                                        DEPLOY_URL
                                                                                    }}/assets/images/missing.png"
                                                                                    class="product-image"
                                                                                    [alt]="customization.description"
                                                                                    appDeferImageLoad
                                                                                    [imageSrc]="customization.image" />
                                                                            </div>
                                                                            <div class="ui-card-content">
                                                                                <div class="cust-product-name">
                                                                                    {{ customization.label }}
                                                                                    <span>{{ customization.description }}</span>
                                                                                </div>
                                                                                <ng-container
                                                                                    *ngTemplateOutlet="
                                                                                        priceContainer;
                                                                                        context: { item: customization }
                                                                                    "></ng-container>
                                                                            </div>
                                                                        </ui-card>
                                                                    </mat-list-item>
                                                                }
                                                            </mat-list>
                                                        }
                                                    </div>
                                                }
                                                @if (!customization_type.show_images) {
                                                    <div class="cs_text conditional_width">
                                                        @if (!customization_type.intrinsic) {
                                                            <!-- Radio Button with compulsory 1 selection -->
                                                            @if (customization_type.min === customization_type.max) {
                                                                <div class="pack_box display">
                                                                    @for (
                                                                        customization of getCustomizations(customization_type.id);
                                                                        track customization
                                                                    ) {
                                                                        <mat-radio-group>
                                                                            <mat-radio-button
                                                                                type="radio"
                                                                                color="primary"
                                                                                class="csrow_text"
                                                                                (click)="
                                                                                    toggleCustomization(
                                                                                        customization_type.id,
                                                                                        customization.id
                                                                                    )
                                                                                "
                                                                                [disableRipple]="true"
                                                                                [checked]="
                                                                                    isSelected('customization', customization.id)
                                                                                "
                                                                                [value]="customization">
                                                                                <div>
                                                                                    @if (!customization.veg) {
                                                                                        <img
                                                                                            height="12"
                                                                                            src="{{
                                                                                                DEPLOY_URL
                                                                                            }}/assets/images/non-veg.svg" />
                                                                                    }
                                                                                    @if (customization.veg) {
                                                                                        <img
                                                                                            height="12"
                                                                                            src="{{
                                                                                                DEPLOY_URL
                                                                                            }}/assets/images/veg.svg" />
                                                                                    }
                                                                                </div>
                                                                                <div class="customization-container">
                                                                                    <div class="customization-name">
                                                                                        {{ customization.label }}
                                                                                    </div>
                                                                                    <div class="customization-price">
                                                                                        <ng-container
                                                                                            *ngTemplateOutlet="
                                                                                                priceContainer;
                                                                                                context: { item: customization }
                                                                                            "></ng-container>
                                                                                    </div>
                                                                                </div>
                                                                            </mat-radio-button>
                                                                        </mat-radio-group>
                                                                    }
                                                                </div>
                                                            }
                                                            <!-- Checkbox with min=any and max=any -->
                                                            @if (customization_type.min !== customization_type.max) {
                                                                <div class="pack_box display checkbox-container">
                                                                    @for (
                                                                        customization of getCustomizations(customization_type.id);
                                                                        track customization
                                                                    ) {
                                                                        <mat-checkbox
                                                                            class="csrow_text"
                                                                            type="checkbox"
                                                                            color="primary"
                                                                            (change)="
                                                                                toggleCustomization(
                                                                                    customization_type.id,
                                                                                    customization.id,
                                                                                    $event
                                                                                )
                                                                            "
                                                                            [checked]="
                                                                                isSelected('customization', customization.id)
                                                                            "
                                                                            [disableRipple]="true">
                                                                            <div>
                                                                                @if (!customization.veg) {
                                                                                    <img
                                                                                        height="12"
                                                                                        src="{{
                                                                                            DEPLOY_URL
                                                                                        }}/assets/images/non-veg.svg" />
                                                                                }
                                                                                @if (customization.veg) {
                                                                                    <img
                                                                                        height="12"
                                                                                        src="{{
                                                                                            DEPLOY_URL
                                                                                        }}/assets/images/veg.svg" />
                                                                                }
                                                                            </div>
                                                                            <div class="customization-container">
                                                                                <div class="customization-name">
                                                                                    {{ customization.label }}
                                                                                </div>
                                                                                <div class="customization-price">
                                                                                    <ng-container
                                                                                        *ngTemplateOutlet="
                                                                                            priceContainer;
                                                                                            context: { item: customization }
                                                                                        "></ng-container>
                                                                                </div>
                                                                            </div>
                                                                        </mat-checkbox>
                                                                    }
                                                                </div>
                                                            }
                                                        } @else {
                                                            <div class="line">
                                                                {{ getIntrinsicCustomizationLabel(customization_type) }}
                                                            </div>
                                                        }
                                                        <ng-template #intrinsic>
                                                            <div class="line">
                                                                {{ getIntrinsicCustomizationLabel(customization_type) }}
                                                            </div>
                                                        </ng-template>
                                                    </div>
                                                }
                                            </div>
                                            <div class="clearfix"></div>
                                            @if (!customization_type.intrinsic) {
                                                <hr class="menu-cust" />
                                            }
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <mat-dialog-actions class="checkout-options" *appFeatureToggle="'mobile'">
                        <ui-counter-button
                            [customStyles]="{ height: '40px', width: '90px' }"
                            [counter]="getProductQuantity()"
                            (onCounterChange)="updateQuantity($event)">
                        </ui-counter-button>
                        <button btn-primary (click)="updateCart()" data-test="addtocart-btn" class="addtocart-btn">
                            &#8377;{{ getFinalPrice() }}&nbsp;&nbsp;|&nbsp;&nbsp;ADD TO CART
                        </button>
                    </mat-dialog-actions>
                </mat-dialog-content>
            </div>
        </div>
        <div class="flex" style="justify-content: flex-end; padding: 1rem" *appFeatureToggle="'desktop'">
            <button
                btn-primary
                size="full"
                style="width: 160px"
                data-test="addtocart-btn"
                [isLoading]="submitCartInProgress"
                (click)="updateCart()">
                ADD TO CART
            </button>
        </div>
    </div>
}
